<template>
  <div
    ref="modal"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div
      class="
        modal-dialog
        modal-dialog-centered
        modal-xxl
        modal-fullscreen-lg-down
        modal-dialog-scrollable
      "
    >
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="btn btn-toolbar"
            :aria-label="$t(`cataloge.back`)"
            v-on:click="back()"
            v-if="editItem || showProducts"
          >
            <BaseIcon name="left-arrow2" />
          </button>
          <h5 class="modal-title" id="staticBackdropLabel">
            {{ $t("manufacturingOperationsModal.manufacturingOperations") }}
          </h5>
          <div class="dropdown d-inline-block ms-3" v-if="!showProducts">
            <button
              class="btn btn-secondary btn-sm dropdown-toggle"
              type="button"
              id="addGroupDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <BaseIcon name="plus" />
              {{ $t("manufacturingOperationsModal.addGroup") }}
            </button>
            <ul class="dropdown-menu" aria-labelledby="addGroupDropdown">
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  v-on:click.prevent="addGroup('start')"
                >
                  {{ $t("manufacturingOperationsModal.addGroupStart") }}
                </a>
              </li>
              <li>
                <a
                  class="dropdown-item"
                  href="#"
                  v-on:click.prevent="addGroup('end')"
                >
                  {{ $t("manufacturingOperationsModal.addGroupEnd") }}
                </a>
              </li>
            </ul>
          </div>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            :aria-label="$t(`addNewContactsModal.close`)"
          ></button>
        </div>
        <div class="modal-body" ref="modalBody">
          <div v-show="!showProducts">
            <draggable
              class="dragArea row custom-input whitebg-input"
              tag="ul"
              :list="operationSteps"
              :group="{ name: 'g1', pull: true, put: true }"
              item-key="index"
              filter="input, textarea"
              :prevent-on-filter="false"
              v-bind="dragOptions"
              :forceFallback="true"
              :fallbackOnBody="true"
              :scroll="true"
              :scrollSensitivity="100"
              handle=".drag-handle"
            >
              <template #item="{ element, index }">
                <li
                  class="col-12 my-3"
                  v-if="element.type === 'group'"
                  :key="`group-${index}`"
                >
                  <div class="card p-3 bg-light border-secondary">
                    <div
                      class="
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-3
                      "
                    >
                      <h6 class="mb-0 drag-handle cursor-move">
                        {{
                          $t("manufacturingOperationsModal.group", {
                            ordinal_suffix_of: ordinalSuffixOf(index),
                          })
                        }}
                      </h6>
                      <div class="d-flex align-items-center">
                        <label class="cstm-check d-flex me-3">
                          <span class="regular-12 text-black mt-3">
                            <BaseIcon
                              name="parallel"
                              :title="
                                $t('manufacturingOperationsModal.parallel')
                              "
                            />
                            {{ $t("manufacturingOperationsModal.parallel") }}
                          </span>
                          <input
                            type="checkbox"
                            v-model="element.parallel"
                            :value="true"
                          />
                          <span class="checkmark mt-3"></span>
                        </label>
                        <button
                          class="btn btn-secondary btn-sm"
                          v-on:click="deleteRow(index)"
                          v-if="element.steps?.length < 1"
                        >
                          <BaseIcon name="trash" />
                        </button>
                      </div>
                    </div>
                    <draggable
                      class="dragArea row m-0 p-0"
                      tag="ul"
                      :list="element.steps"
                      :group="{ name: 'g1', pull: true, put: true }"
                      item-key="index"
                      filter="input, textarea"
                      :prevent-on-filter="false"
                      v-bind="dragOptions"
                      :forceFallback="true"
                      :fallbackOnBody="true"
                      handle=".drag-handle"
                    >
                      <template #item="{ element: step, index: stepIndex }">
                        <li
                          class="col-12 mt-2"
                          :key="`substep-${index}-${stepIndex}`"
                        >
                          <div class="row align-items-center">
                            <div class="col-auto">
                              <BaseIcon
                                name="order"
                                class="drag-handle cursor-move"
                              />
                            </div>
                            <div class="col-2">
                              <span class="regular-12 text-black">
                                {{ getStepOrdinal(index) }}/{{
                                  getSubStepOrdinal(index, stepIndex)
                                }}
                              </span>
                              <v-select
                                :options="operations"
                                label="name"
                                :reduce="(e) => e.id"
                                v-model="step.id"
                                :placeholder="
                                  $t(
                                    `manufacturingOperationsModal.manufacturingOperations`
                                  )
                                "
                                v-on:option:selected="
                                  selectedItem($event, index)
                                "
                                :filter="filterOperations"
                                v-on:search="
                                  searchOpearationDescriptions(
                                    step,
                                    index + '_' + stepIndex,
                                    $event,
                                    $event
                                  )
                                "
                                append-to-body
                              />
                            </div>
                            <div class="col-2 col-xxl-3">
                              <label class="form-label bold-12 text-gray">{{
                                $t("manufacturingOperationsModal.description")
                              }}</label>
                              <v-select
                                v-model="step.description"
                                label="description"
                                taggable
                                :reduce="(e) => e.description"
                                :options="
                                  opearationDescriptions[
                                    index + '_' + stepIndex
                                  ] || []
                                "
                                :placeholder="
                                  $t(`manufacturingOperationsModal.description`)
                                "
                                v-on:search="
                                  searchOpearationDescriptions(
                                    step,
                                    index + '_' + stepIndex,
                                    $event,
                                    $event
                                  )
                                "
                                v-on:open="
                                  searchOpearationDescriptions(
                                    step,
                                    index + '_' + stepIndex,
                                    '',
                                    $event,
                                    true
                                  )
                                "
                                append-to-body
                              />
                            </div>
                            <div class="col">
                              <label class="form-label bold-12 text-gray">{{
                                $t("manufacturingOperationsModal.more2")
                              }}</label>
                              <textarea
                                class="form-control w-100"
                                v-model="step.extra_info"
                              />
                            </div>
                            <div class="col-1_75 col-xxxl-1_5">
                              <label class="form-label bold-12 text-gray">{{
                                $t("manufacturingOperationsModal.time")
                              }}</label>
                              <div class="fix-end-input">
                                <input
                                  type="number"
                                  class="form-control"
                                  v-model="step.time"
                                />
                                <span>{{
                                  $t("manufacturingOperationsModal.sec")
                                }}</span>
                              </div>
                            </div>
                            <div class="col-0_5" v-if="index === 0"></div>
                            <div class="col-0_5" v-else>
                              <label
                                class="
                                  form-label
                                  bold-12
                                  text-gray
                                  overflow-hidden
                                "
                              >
                                <BaseIcon
                                  name="parallel"
                                  :title="
                                    $t('manufacturingOperationsModal.parallel')
                                  "
                                />
                              </label>
                              <label class="cstm-check mt-3 mb-4">
                                <input
                                  type="checkbox"
                                  :value="true"
                                  :disabled="lockData && lock"
                                  v-model="step.parallel"
                                />
                                <span class="checkmark"></span>
                              </label>
                            </div>
                            <div class="col-auto d-flex">
                              <button
                                class="btn btn-secondary btn-sm btn-no-r"
                                :title="
                                  $t(`manufacturingOperationsModal.getTimes`)
                                "
                                v-on:click="getTimes(step)"
                              >
                                <BaseIcon name="clock" />
                              </button>
                              <button
                                class="
                                  btn btn-secondary btn-sm btn-no-r btn-no-l
                                "
                                :class="
                                  step.videos_count > 0
                                    ? ' bg-success text-white'
                                    : ''
                                "
                                :title="
                                  $t(
                                    `manufacturingOperationsModal.manageVideos`
                                  )
                                "
                                v-on:click="editVideos(step)"
                              >
                                <BaseIcon name="video" />
                              </button>
                              <button
                                class="
                                  btn btn-secondary btn-sm btn-no-r btn-no-l
                                "
                                v-on:click="addRowToGroup(index, stepIndex)"
                              >
                                <BaseIcon name="plus" />
                              </button>
                              <button
                                class="btn btn-secondary btn-sm btn-no-l"
                                v-on:click="
                                  deleteStepFromGroup(index, stepIndex)
                                "
                              >
                                <BaseIcon name="trash" />
                              </button>
                            </div>
                          </div>
                        </li>
                      </template>
                    </draggable>
                  </div>
                </li>
                <li class="row" v-else :key="`step-${index}`">
                  <div class="col-auto">
                    <BaseIcon name="order" class="drag-handle cursor-move" />
                  </div>
                  <div class="col-2">
                    <div class="mb-3">
                      <label class="form-label bold-12 text-gray"
                        >{{
                          $t(`manufacturingOperationsModal.step`, {
                            ordinal_suffix_of: ordinalSuffixOf(index),
                          })
                        }}
                      </label>
                      <v-select
                        v-model="element.id"
                        taggable
                        :reduce="(e) => e.id"
                        :options="
                          focusedIndex === index
                            ? filteredOperations
                            : operations
                        "
                        v-on:input="focusedIndex = index"
                        v-on:open="focusedIndex = index"
                        v-on:search="filterOperations"
                        :filterable="false"
                        :create-option="(v) => createOption(v)"
                        v-on:option:selected="(e) => selectedItem(e)"
                        label="name"
                        :disabled="lockData && lock"
                        append-to-body
                      />
                    </div>
                  </div>
                  <div class="col-2 col-xxl-3">
                    <div class="mb-3">
                      <label class="form-label bold-12 text-gray">{{
                        $t("manufacturingOperationsModal.description")
                      }}</label>
                      <v-select
                        v-model="element.description"
                        taggable
                        :options="opearationDescriptions[index]"
                        v-on:search="
                          (q, l) =>
                            searchOpearationDescriptions(element, index, q, l)
                        "
                        v-on:focusin="
                          searchOpearationDescriptions(
                            element,
                            index,
                            '',
                            (e) => {},
                            true
                          )
                        "
                        :disabled="lockData && lock"
                        :filterable="true"
                        append-to-body
                      >
                        <template v-slot:selected-option="option">
                          {{ option.label }}
                        </template>
                        <template v-slot:option="option">
                          <span class="regular-10">{{ option.label }}</span>
                        </template>
                      </v-select>
                    </div>
                  </div>
                  <div class="col">
                    <label class="form-label bold-12 text-gray">{{
                      $t("manufacturingOperationsModal.more2")
                    }}</label>
                    <textarea
                      class="form-control w-100"
                      v-model="element.extra_info"
                      :disabled="lockData && lock"
                    />
                  </div>
                  <div class="col-1_75 col-xxxl-1_5">
                    <label class="form-label bold-12 text-gray">{{
                      $t("manufacturingOperationsModal.time")
                    }}</label>
                    <div class="fix-end-input">
                      <input
                        type="number"
                        v-model="element.time"
                        class="form-control"
                        :disabled="lockData && lock"
                        min="1"
                      />
                      <span>{{ $t("manufacturingOperationsModal.sec") }}</span>
                    </div>
                  </div>
                  <div class="col-0_5" v-if="index === 0"></div>
                  <div class="col-0_5" v-else>
                    <label class="form-label bold-12 text-gray overflow-hidden">
                      <BaseIcon
                        name="parallel"
                        :title="$t('manufacturingOperationsModal.parallel')"
                      />
                    </label>
                    <label class="cstm-check mt-3 mb-4">
                      <input
                        type="checkbox"
                        :value="true"
                        :disabled="lockData && lock"
                        v-model="element.parallel"
                      />
                      <span class="checkmark"></span>
                    </label>
                  </div>
                  <div class="col-auto">
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-r"
                      :title="$t(`manufacturingOperationsModal.getTimes`)"
                      v-on:click="getTimes(element)"
                    >
                      <BaseIcon name="clock" />
                    </button>
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-r btn-no-l"
                      :title="$t(`manufacturingOperationsModal.manageVideos`)"
                      :class="
                        element.videos_count > 0 ? ' bg-success text-white' : ''
                      "
                      v-on:click="editVideos(element)"
                    >
                      <BaseIcon name="video" />
                    </button>
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-r btn-no-l"
                      v-on:click="addRow(index)"
                    >
                      <BaseIcon name="plus" />
                    </button>
                    <button
                      class="mt-4 btn btn-secondary btn-sm btn-no-l"
                      v-on:click="deleteRow(index)"
                    >
                      <BaseIcon name="trash" />
                    </button>
                  </div>
                </li>
              </template>
            </draggable>
          </div>
          <div v-if="showProducts">
            <DynamicTable
              v-model:rows="rows"
              v-model:items="products"
              :fix-height="false"
              :show-order="false"
              :show-pin="false"
              type="operations"
              :key="tableKey"
            />
          </div>
        </div>
        <div class="modal-footer">
          <div class="row mt-4 w-100">
            <div class="col-6">
              <label class="cstm-check d-flex">
                <span class="regular-12 text-black mt-3">
                  {{ $t("ingredients.lock") }}
                </span>
                <input
                  type="checkbox"
                  v-model="lockData"
                  :value="true"
                  v-on:change="save(true)"
                />
                <span class="checkmark mt-3"></span>
              </label>
            </div>
            <div class="col-6 text-end">
              <button
                class="btn btn-type-2"
                v-if="!editItem"
                v-on:click="save()"
                :disabled="lockData && lock"
              >
                <span>{{ $t("finance.save") }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ManufacturingOperationVideosModal
    :productId="id"
    :operationId="editVideoData"
    ref="operationVideosModal"
    type="operation"
    v-on:video-count="updateVideoCount"
  />
  <ConfirmModal
    ref="createModal"
    :title="$t(`manufacturingOperationsModal.createOperation`)"
    :text="`<ul><li>You will create a new operation<b></li></ul><p>Are you sure you want to continue?</p>`"
    cancel-button="No, cancel"
    :ok-button="`Yes, create ${createObject?.name}`"
    v-on:success="createOperation"
  />
</template>

<script>
import tenant from "../../modules/tenant";

const bootstrap = require("bootstrap");
import http from "@/modules/http";
import { useStore } from "vuex";
import draggable from "vuedraggable";
import BaseIcon from "../icons/BaseIcon";
import ManufacturingOperationVideosModal from "./ManufacturingOperationVideosModal";
import ConfirmModal from "./ConfirmModal";
import DynamicTable from "../lists/DynamicTable";

export default {
  name: "ManufacturingOperationsModal",
  props: {
    modelValue: Array,
    id: Number,
    lock: Boolean,
  },
  components: {
    DynamicTable,
    ConfirmModal,
    BaseIcon,
    draggable,
    ManufacturingOperationVideosModal,
  },
  data() {
    return {
      dragOptions: {
        animation: 200,
        disabled: false,
        ghostClass: "ghost",
      },
      showProducts: false,
      products: [],
      createObject: null,
      scrollTop: 0,
      editItem: null,
      store: useStore(),
      myModal: undefined,
      operationSteps: [{ id: null }],
      editVideoData: null,
      editVideoRef: null,
      lockData: this.lock,
      previousSearches: {},
      opearationDescriptions: {},
      filterQ: "",
      focusedIndex: 0,
      tableKey: 0,
      rows: [
        {
          name: "Image",
          key: "image",
          type: "image",
          show: true,
          editable: false,
        },
        {
          name: "Serial",
          key: "serial",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Time",
          key: "time",
          type: "number",
          show: true,
          editable: false,
        },
        {
          name: "Description",
          key: "description",
          type: "string",
          show: true,
          editable: false,
        },
        {
          name: "Extra info",
          key: "extra_info",
          type: "string",
          show: true,
          editable: false,
        },
      ],
      columnNumbers: [
        this.$t("serialNumbers.first"),
        this.$t("serialNumbers.second"),
        this.$t("serialNumbers.third"),
        this.$t("serialNumbers.fourth"),
        this.$t("serialNumbers.fifth"),
        this.$t("serialNumbers.sixth"),
        this.$t("serialNumbers.seventh"),
        this.$t("serialNumbers.eighth"),
        this.$t("serialNumbers.ninth"),
        this.$t("serialNumbers.tenth"),
      ],
    };
  },
  computed: {
    mediaServer() {
      return tenant.getAppMediaUrl();
    },
    operations() {
      return this.store.state.operations;
    },
    filteredOperations() {
      if (this.filterQ.length < 2) {
        return this.operations;
      }

      const searchTerm = this.filterQ.toLowerCase();

      return this.operations
        .filter(
          (item) => item.name && item.name.toLowerCase().includes(searchTerm)
        )
        .sort((a, b) => {
          const startsWithA = a.name.toLowerCase().startsWith(searchTerm);
          const startsWithB = b.name.toLowerCase().startsWith(searchTerm);

          if (startsWithA && !startsWithB) return -1;
          if (!startsWithA && startsWithB) return 1;

          return a.name.localeCompare(b.name);
        });
    },
  },
  methods: {
    ordinalSuffixOf(i, list = null, asText = false) {
      if (list === null) {
        list = this.operationSteps;
      }
      if (i > 0 && list[i]?.parallel) {
        return this.ordinalSuffixOf(i - 1, list);
      }
      // Calculate real index by skipping parallel ones
      let realIndex = 0;
      for (let j = 0; j <= i; j++) {
        if (!list[j]?.parallel) {
          realIndex++;
        }
      }
      const val = realIndex;
      if (asText && val < 10) {
        return this.columnNumbers[val - 1];
      }
      if (this.$i18n.locale !== "en") {
        return val + ".";
      }
      let j = val % 10,
        k = val % 100;
      if (j === 1 && k !== 11) {
        return val + "st";
      }
      if (j === 2 && k !== 12) {
        return val + "nd";
      }
      if (j === 3 && k !== 13) {
        return val + "rd";
      }
      return val + "th";
    },
    getStepOrdinal(index) {
      // Find the first non-parallel index at or before current index
      let actualIndex = index;
      while (actualIndex > 0 && this.operationSteps[actualIndex]?.parallel) {
        actualIndex--;
      }

      // Count non-parallel items up to actualIndex
      let ordinal = 0;
      for (let i = 0; i <= actualIndex; i++) {
        if (!this.operationSteps[i]?.parallel) {
          ordinal++;
        }
      }
      return ordinal;
    },
    getSubStepOrdinal(groupIndex, stepIndex) {
      const steps = this.operationSteps[groupIndex].steps;
      // Find the first non-parallel index at or before current index
      let actualIndex = stepIndex;
      while (actualIndex > 0 && steps[actualIndex]?.parallel) {
        actualIndex--;
      }

      // Count non-parallel items up to actualIndex
      let ordinal = 0;
      for (let i = 0; i <= actualIndex; i++) {
        if (!steps[i]?.parallel) {
          ordinal++;
        }
      }
      return ordinal;
    },
    showModal() {
      const mapSteps = (steps) => {
        let result = [];
        for (const val of steps) {
          if (val.type === "group") {
            result.push({
              type: "group",
              parallel: val.parallel,
              steps: mapSteps(val.steps),
              step_id: val.step_id ?? val.id ?? null,
            });
          } else {
            result.push({
              id: val.manufacturing_operation_id,
              manufacturing_operation_id: val.manufacturing_operation_id,
              parallel: val.parallel ?? val.pivot?.parallel,
              time: val.time ?? val.pivot?.time,
              description: val.description ?? val.pivot?.description ?? "",
              extra_info: val.extra_info ?? val.pivot?.extra_info ?? "",
              step_id: val.step_id ?? val.id ?? null,
              videos_count: val.videos_count ?? val.pivot?.videos_count ?? 0,
              type: "step",
            });
          }
        }
        return result;
      };

      this.operationSteps = mapSteps(this.modelValue);

      if (this.myModal === undefined) {
        this.myModal = new bootstrap.Modal(this.$refs.modal, {
          backdrop: "static",
        });
      }
      this.myModal.show();
    },
    addRow(index) {
      this.operationSteps.splice(index + 1, 0, { id: null, type: "step" });
    },
    addRowToGroup(groupIndex, stepIndex) {
      this.operationSteps[groupIndex].steps.splice(stepIndex + 1, 0, {
        id: null,
        type: "step",
      });
    },
    addGroup(position = "end") {
      const group = {
        type: "group",
        parallel: false,
        steps: [{ id: null, type: "step" }],
      };
      if (position === "start") {
        this.operationSteps.unshift(group);
      } else {
        this.operationSteps.push(group);
      }
    },
    deleteRow(index) {
      if (this.operationSteps.length > 1) {
        this.operationSteps.splice(index, 1);
      }
    },
    deleteStepFromGroup(groupIndex, stepIndex) {
      if (this.operationSteps[groupIndex].steps.length > 1) {
        this.operationSteps[groupIndex].steps.splice(stepIndex, 1);
      } else {
        this.deleteRow(groupIndex);
      }
    },
    createOption(v) {
      let i = this.operations.find(
        (e) => e.name.toLowerCase().indexOf(v.toLowerCase()) > -1
      );
      if (i !== null && i !== undefined) {
        return i;
      }
      return { id: "new_" + Date.now(), name: v };
    },
    createOperation() {
      http
        .fetch(`/manufacturing/operations`, { name: this.createObject.name })
        .then((data) => {
          const oldId = this.createObject.id;
          this.createObject.id = data.id;
          this.operations.push(data);
          const updateId = (steps) => {
            for (const step of steps) {
              if (step.id === oldId) {
                step.id = data.id;
              }
              if (step.steps) {
                updateId(step.steps);
              }
            }
          };
          updateId(this.operationSteps);
          this.createObject = null;
        });
    },
    selectedItem(e, groupIndex = null) {
      if (typeof e.id === "string" && e.id.indexOf("new_") === 0) {
        this.createObject = e;
        this.$refs.createModal.showModal();
      }
      let steps =
        groupIndex !== null
          ? this.operationSteps[groupIndex].steps
          : this.operationSteps;
      let hasNull = false;
      for (let p = 0; p < steps.length; p++) {
        if (steps[p].id === null) {
          if (p !== steps.length - 1) {
            steps.splice(p, 1);
            p--;
          } else {
            hasNull = true;
          }
        }
      }
      if (!hasNull) {
        steps.push({ id: null, type: "step" });
      }
    },
    getTimes(e) {
      http
        .fetch(
          `/manufacturing/operations/descriptions/times?q=${encodeURIComponent(
            e.description
          )}&id=${e.id}&category_filter_by_product_id=${this.id}`
        )
        .then((data) => {
          for (const product of data) {
            product.image =
              product.image !== null
                ? product.image.indexOf("http") === 0
                  ? product.image
                  : this.mediaServer + "/" + product.image
                : null;
          }
          this.products = data;
          this.showProducts = true;
        });
    },
    editVideos(e) {
      this.editVideoData = e.step_id;
      this.editVideoRef = e;
      this.$refs.operationVideosModal.showModal();
    },
    updateVideoCount(count) {
      this.editVideoRef.videos_count = count;
    },
    back() {
      this.editItem = null;
      this.showProducts = false;
    },
    searchOpearationDescriptions(
      e,
      index,
      search,
      loading,
      onlyIfEmpty = false
    ) {
      if (this.opearationDescriptions[index]?.length > 0 && onlyIfEmpty) return;
      if (!onlyIfEmpty && search.length < 3) return;

      const prev = this.previousSearches[index] || "";
      const isCharRemoved = search.length <= prev.length && prev !== search;
      const currentList = this.opearationDescriptions[index] || [];

      if (
        currentList.length > 0 &&
        currentList.length < 100 &&
        !isCharRemoved
      ) {
        return;
      }

      this.previousSearches[index] = search;

      loading(true);

      http
        .fetch(
          `/manufacturing/operations/descriptions/search?q=${search}&id=${
            e.id || ""
          }`
        )
        .then((data) => {
          this.opearationDescriptions[index] = data;
          loading(false);
        })
        .catch(() => loading(false));
    },
    save(onlyLock = false) {
      if (onlyLock && this.lockData) {
        return;
      }

      const process = (steps) => {
        let result = [];
        for (const p of steps) {
          if (
            (p.id !== null && p.id !== undefined) ||
            (p.type === "group" && p.steps?.length > 0)
          ) {
            let item = { ...p };
            if (item.type === "group") {
              item.steps = process(item.steps);
              if (item.steps.length > 0) {
                if (item.id === undefined) {
                  delete item.id;
                }
                result.push(item);
              }
            } else {
              if (item.step_id === undefined || item.step_id === null) {
                delete item.step_id;
              }
              if (item.pivot?.id && !item.step_id) {
                item.step_id = item.pivot.id;
              }
              if (item.description === undefined) {
                delete item.description;
              }
              if (item.parallel === undefined) {
                item.parallel = false;
              }
              if (item.id === undefined) {
                delete item.id;
              }
              if (item.id !== null) {
                item.name = this.operations.find((e) => e.id === item.id)?.name;
              }
              result.push(item);
            }
          }
        }
        return result;
      };
      let toSave = process(this.operationSteps);

      console.log(toSave);
      console.log(this.modelValue);

      this.$emit("update:lock", this.lockData);
      this.$emit("update:modelValue", toSave);
      if (!onlyLock) {
        this.myModal.hide();
      }
    },
    filterOperations(search, loading) {
      loading(true);
      this.filterQ = search;
      loading(false);
    },
  },
  emits: ["update:modelValue", "update:lock"],
};
</script>
<style scoped>
ul {
  list-style-type: none;
}
.dragArea {
  min-height: 2px;
  margin-bottom: 2em;
}
.cursor-move {
  cursor: move !important;
}
</style>
